
<app-input [label]="label" [disable]="true" customClasses="!bg-gray-50">
    <div class="content" [ngClass]="customClasses">
        <span class="font-medium"> {{drug?.friendlyName}} </span> <span class="opacity-75"> | NDC 
            {{drug?.packageNdc}}</span>
        </div>
</app-input>